"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { areEqualAddresses } from "@/helpers/Helpers";
import { useIsDropForgeAdmin } from "@/hooks/useIsDropForgeAdmin";
export function useDropForgePermissions() {
  const $ = _c(26);
  const {
    address,
    connectionState
  } = useSeizeConnectContext();
  const {
    seizeSettings,
    isLoaded
  } = useSeizeSettings();
  let t0;
  if ($[0] !== seizeSettings.distribution_admin_wallets) {
    t0 = JSON.stringify(seizeSettings.distribution_admin_wallets ?? []);
    $[0] = seizeSettings.distribution_admin_wallets;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const distributionAdminWalletsKey = t0;
  let t1;
  if ($[2] !== seizeSettings.claims_admin_wallets) {
    t1 = JSON.stringify(seizeSettings.claims_admin_wallets ?? []);
    $[2] = seizeSettings.claims_admin_wallets;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const claimsAdminWalletsKey = t1;
  let t2;
  if ($[4] !== distributionAdminWalletsKey) {
    t2 = JSON.parse(distributionAdminWalletsKey);
    $[4] = distributionAdminWalletsKey;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const distributionAdminWallets = t2 as string[];
  let t3;
  if ($[6] !== claimsAdminWalletsKey) {
    t3 = JSON.parse(claimsAdminWalletsKey);
    $[6] = claimsAdminWalletsKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const claimsAdminWallets = t3 as string[];
  const {
    isDropForgeAdmin,
    isFetching: isDropForgeAdminFetching
  } = useIsDropForgeAdmin();
  const hasWallet = !!address;
  const isWalletInitializing = connectionState === "initializing";
  const permissionsLoading = isWalletInitializing || hasWallet && !isLoaded || hasWallet && isDropForgeAdminFetching;
  let t4;
  if ($[8] !== address || $[9] !== distributionAdminWallets || $[10] !== hasWallet) {
    t4 = hasWallet && distributionAdminWallets.some(w => areEqualAddresses(w, address));
    $[8] = address;
    $[9] = distributionAdminWallets;
    $[10] = hasWallet;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const isDistributionAdmin = t4;
  let t5;
  if ($[12] !== address || $[13] !== claimsAdminWallets || $[14] !== hasWallet) {
    t5 = hasWallet && claimsAdminWallets.some(w_0 => areEqualAddresses(w_0, address));
    $[12] = address;
    $[13] = claimsAdminWallets;
    $[14] = hasWallet;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const isClaimsAdmin = t5;
  const canLaunch = hasWallet && (isClaimsAdmin || isDropForgeAdmin);
  const canAccessLanding = hasWallet && (isDistributionAdmin || isClaimsAdmin || isDropForgeAdmin);
  const canAccessCraft = isDistributionAdmin;
  const canAccessLaunchPage = canLaunch;
  let t6;
  if ($[16] !== canAccessCraft || $[17] !== canAccessLanding || $[18] !== canAccessLaunchPage || $[19] !== canLaunch || $[20] !== hasWallet || $[21] !== isClaimsAdmin || $[22] !== isDistributionAdmin || $[23] !== isDropForgeAdmin || $[24] !== permissionsLoading) {
    t6 = {
      hasWallet,
      permissionsLoading,
      canAccessLanding,
      canAccessCraft,
      canAccessLaunch: canLaunch,
      canAccessLaunchPage,
      isDistributionAdmin,
      isClaimsAdmin,
      isDropForgeAdmin
    };
    $[16] = canAccessCraft;
    $[17] = canAccessLanding;
    $[18] = canAccessLaunchPage;
    $[19] = canLaunch;
    $[20] = hasWallet;
    $[21] = isClaimsAdmin;
    $[22] = isDistributionAdmin;
    $[23] = isDropForgeAdmin;
    $[24] = permissionsLoading;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
}